import React from 'react';
import PropTypes from 'prop-types';
import AdvModal from '../CommonComponents/AdvModal';
import AlightTermsView from './AlightTermsView';
import { LanguagePreference } from '../ClientGetStartedModal/components/LanguagePreference/LanguagePreference';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { Background } from './components/Background/Background';

const EVENT_LISTENER_NAMES = [
  'webkitfullscreenchange',
  'mozfullscreenchange',
  'msfullscreenchange',
  'fullscreenchange',
];

const onFullscreenChanged = () => {
  const element =
    document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
  if (element && element.nodeName === 'VIDEO') {
    document.getElementById('master_container').style.display = 'none';
  } else {
    document.getElementById('master_container').style.display = '';
  }
};

const addFullscreenEventListener = (element, eventListener) => {
  EVENT_LISTENER_NAMES.forEach(eventListenerName =>
    element.addEventListener(eventListenerName, eventListener),
  );
};
const removeFullScreenEventListener = (element, eventListener) => {
  EVENT_LISTENER_NAMES.forEach(eventListenerName =>
    element.removeEventListener(eventListenerName, eventListener),
  );
};

const handleStateChange = (nextState, previousState) => {
  if (nextState.isFullscreen && !previousState.isFullscreen) {
    document.getElementById('master_container').style.display = 'none';
  } else if (!nextState.isFullscreen && previousState.isFullscreen) {
    document.getElementById('master_container').style.display = '';
  }
};

class AlightView extends React.Component {
  constructor() {
    super();
    this.state = {
      hasSelectedLanguage: false,
      isVideo: false,
      checked: false,
    };
    this.onVideoRef = this.onVideoRef.bind(this);
    this.onPlayerRef = this.onPlayerRef.bind(this);
    this.onCheckboxToggle = this.onCheckboxToggle.bind(this);
    this.onVideoToggle = this.onVideoToggle.bind(this);
  }

  onCheckboxToggle({ target: { checked } }) {
    this.setState({
      checked,
    });
  }

  onVideoToggle() {
    this.setState({
      isVideo: !this.state.isVideo,
    });
  }

  onPlayerRef(playerElement) {
    if (playerElement && playerElement.video) {
      this.onVideoRef(playerElement.video.video);
      playerElement.subscribeToStateChange(handleStateChange);
    } else {
      this.onVideoRef(null);
    }
  }

  onVideoRef(videoElement) {
    if (this.videoElement) {
      removeFullScreenEventListener(this.videoElement, onFullscreenChanged);
    }
    if (videoElement) {
      addFullscreenEventListener(videoElement, onFullscreenChanged);
    }
    this.videoElement = videoElement;
  }

  render() {
    const { name, agreementText, csrf, portalName, clientId, showLanguagePreference } = this.props;
    const { checked, hasSelectedLanguage } = this.state;
    const VIMEO_URL = 'https://player.vimeo.com/video/740863814?autoplay=1';

    if (showLanguagePreference && !hasSelectedLanguage) {
      return (
        <>
          <Modal isOpen aria={{ labelledby: 'language-selection-modal--header' }}>
            <ModalHeader id="language-selection-modal--header">Language Preference</ModalHeader>

            <LanguagePreference
              clientId={clientId}
              onNext={() => this.setState({ hasSelectedLanguage: true })}
            />
          </Modal>

          <div id="Workflow">
            <Background />
          </div>
        </>
      );
    }

    return (
      <div id="Workflow">
        {this.state.isVideo ? (
          <AdvModal
            className="popup video-popup"
            isOpen
            shouldCloseOnOverlayClick={false}
            overlayClassName="closerdiv"
          >
            <i
              role="button"
              tabIndex="0"
              onKeyDown={() => {}}
              onClick={this.onVideoToggle}
              className="fa fa-times close"
            />
            <div
              css={`
                padding: 56.25% 0 0 0;
                position: relative;
              `}
            >
              <iframe
                src={VIMEO_URL}
                frameBorder="0"
                allow="autoplay; fullscreen;"
                title="Learn More"
                css={`
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                `}
              />
            </div>
          </AdvModal>
        ) : (
          <AdvModal
            isOpen
            shouldCloseOnOverlayClick={false}
            className="popup alight-popup"
            overlayClassName="closerdiv"
          >
            <AlightTermsView
              name={name}
              agreementText={agreementText}
              csrf={csrf}
              checked={checked}
              onCheckboxToggle={this.onCheckboxToggle}
              onVideoToggle={this.onVideoToggle}
              portalName={portalName}
            />
          </AdvModal>
        )}

        <Background />
      </div>
    );
  }
}
AlightView.defaultProps = {
  name: '',
  agreementText: '',
  csrf: '',
};

AlightView.propTypes = {
  name: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  showLanguagePreference: PropTypes.bool.isRequired,
  agreementText: PropTypes.string,
  csrf: PropTypes.string,
  portalName: PropTypes.string.isRequired,
};

export default AlightView;
